module.exports = __webpack_public_path__ + "static/img/ms.a677c483.png";